import Flatpickr from 'react-flatpickr';
import { Portuguese } from 'flatpickr/dist/l10n/pt';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { CustomLocale } from 'flatpickr/dist/types/locale';
import 'flatpickr/dist/flatpickr.css';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getCrmColors } from '../../kanban-board/crm-theme';

const locales: Record<string, CustomLocale> = {
    pt: Portuguese,
    es: Spanish,
};

interface Props {
    cc: ReturnType<typeof getCrmColors>;
    selected?: Date;
    onChooseDay: (day: Date) => void;
}

/// Calendário compacto para pular de mês: sem ele, datas distantes exigem clicar semana a semana.
export const AgendaMiniCalendar = ({ cc, selected, onChooseDay }: Props) => {
    const { i18n } = useTranslation();
    const locale = locales[i18n.language?.split('-')[0]] ?? 'default';

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',

                // Em modo inline o input de texto do flatpickr não serve para nada.
                '& .flatpickr-input': { display: 'none' },
                '& .flatpickr-calendar.inline': {
                    boxShadow: 'none',
                    margin: '0 auto',
                    background: 'transparent',
                },

                '& .flatpickr-current-month input.cur-year, & .flatpickr-current-month .flatpickr-monthDropdown-months':
                {
                    color: cc.textPrimary,
                    fontWeight: 600,
                },
                '& .flatpickr-monthDropdown-months option': { color: '#000000' },
                '& .flatpickr-months .flatpickr-prev-month svg, & .flatpickr-months .flatpickr-next-month svg':
                {
                    fill: cc.textPrimary,
                },
                '& .numInputWrapper span.arrowUp:after': { borderBottomColor: cc.textPrimary },
                '& .numInputWrapper span.arrowDown:after': { borderTopColor: cc.textPrimary },

                '& .flatpickr-weekday': { color: cc.textMuted },
                '& .flatpickr-day': { color: cc.textPrimary },
                '& .flatpickr-day.prevMonthDay, & .flatpickr-day.nextMonthDay, & .flatpickr-day.flatpickr-disabled':
                {
                    color: cc.textMuted,
                },

                // Hoje é só um anel; o dia escolhido é preenchido e vence quando coincidem.
                '& .flatpickr-day.today': {
                    background: 'transparent',
                    border: `1px solid ${cc.eventWarning}`,
                    color: cc.textPrimary,
                },
                '& .flatpickr-day.today:hover, & .flatpickr-day.today:focus': {
                    background: `${cc.eventWarning}22 !important`,
                    color: cc.textPrimary,
                },
                '& .flatpickr-day:hover': { background: cc.countBg },
                '& .flatpickr-day.selected, & .flatpickr-day.selected:hover, & .flatpickr-day.selected:focus':
                {
                    background: `${cc.accent} !important`,
                    borderColor: `${cc.accent} !important`,
                    color: '#ffffff !important',
                },
            }}
        >
            <Flatpickr
                value={selected}
                options={{ inline: true, locale }}
                onChange={(dates: Date[]) => {
                    if (dates && dates[0]) onChooseDay(dates[0]);
                }}
            />
        </Box>
    );
};
